import { Component } from '@angular/core';
import { ActivatedRoute, Router, Event } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { StorageKey, StorageService } from '../../services/common/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-sweet-spot-view-layout',
  templateUrl: './sweet-spot-view-layout.component.html',
  styleUrl: './sweet-spot-view-layout.component.scss'
})
export class SweetSpotViewLayoutComponent {
  activeTab: string = '';
  SweetSpotId: number = 0;
  SweetSpotName: string = '';
  HistoryDateList: any[] = [];
  SelectedHistoryDate: any;
  IsHistoryView: boolean = false;
  sweetspotData: any
  UserType: any

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private apiservice: ApiService,
    private url: ApiUrlHelper,
    private storageService: StorageService,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {
    this.translate.setDefaultLang('eng'); 
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length === 0) {
        this.goToList();
      }

      try {
        const DecryptedId = this.getDecrypted(params['id']);
        if (DecryptedId) {
          this.SweetSpotId = Number(DecryptedId);
        }
        const DecryptedName = this.getDecrypted(params['name']);
        if (DecryptedName) {
          this.SweetSpotName = DecryptedName;
        }

        if (params['history']) {
          const DecryptedHistory = this.getDecrypted(params['history']);
          if (DecryptedHistory) {
            this.SelectedHistoryDate = DecryptedHistory;
          }
          else {
            this.SelectedHistoryDate = null;
          }
        }
        else {
          this.SelectedHistoryDate = null;
        }

        if (!DecryptedId || !DecryptedName) {
          this.goToList();
        }
      } catch (error) {
        this.goToList();
      }
    });

    this.router.events.subscribe((event: Event) => {
      // if (event instanceof NavigationStart) {
      //   // Show loading indicator
      // }

      // if (event instanceof NavigationEnd) {
      //   // Hide loading indicator
      // }

      // if (event instanceof NavigationError) {
      //   // Hide loading indicator

      //   // Present error to user
      //   console.log(event.error);
      // }
      this.activeTab = this.route.firstChild?.snapshot.url[0]?.path || '';
    });

    this.getHistoryDate();
  }
  ngOnInit() {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language);
    });
    this.UserType = this.storageService.getTokenData().UserTypeId;
    this.getSweetSpotData()
  }
  getHistoryDate() {
    let url = this.url.apiUrl.DropDownList.SweetSpotHistoryDate.replace("{SweetSpotId}", this.SweetSpotId.toString());
    this.apiservice.doGet(url).subscribe({
      next: (value) => {
        this.HistoryDateList = value.Data;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  getEncrypted(data: any): string {
    return encodeURIComponent(btoa(this.commonService.Encrypt(data.toString())));
  }

  getDecrypted(data: any): string {
    return this.commonService.Decrypt(atob(decodeURIComponent(data.toString())));
  }

  setQueryParam(): object {
    if (this.isDate(this.SelectedHistoryDate) && this.IsHistoryView) {
      let encryptedId = this.getEncrypted(this.SweetSpotId.toString());
      let encryptedName = this.getEncrypted(this.SweetSpotName);
      let encryptedHistory = this.getEncrypted(this.SelectedHistoryDate);
      return { id: encryptedId, name: encryptedName, history: encryptedHistory };
    }
    else {
      let encryptedId = this.getEncrypted(this.SweetSpotId.toString());
      let encryptedName = this.getEncrypted(this.SweetSpotName);
      return { id: encryptedId, name: encryptedName };
    }
  }

  goToPage(pageName: string) {
    this.router.navigate(["/sweet-spot-history-view/" + pageName], { queryParams: this.setQueryParam() });
  }

  isDate(value: any): boolean {
    if (value instanceof Date) {
      return !isNaN(value.getTime());
    }

    if (typeof value === "string") {
      const parsedDate = new Date(value);
      return !isNaN(parsedDate.getTime());
    }

    return false;
  }

  viewHistory() {
    if (this.isDate(this.SelectedHistoryDate)) {
      this.IsHistoryView = true;
    }
    else {
      this.IsHistoryView = false;
    }

    this.router.navigate(["/sweet-spot-history-view/" + this.activeTab], { queryParams: this.setQueryParam() });
  }

  goToList() {
    this.router.navigate(["/sweet-spot-pipeline"]);
  }

  getSweetSpotData() {
    const apiUrl = this.url.apiUrl.SweetSpotpipeline.GetSweetSpotById.replace("{SweetSpotId}", this.SweetSpotId.toString())
    this.apiservice.doGet(apiUrl).pipe().subscribe({
      next: (response) => {
        if (response['Success']) {
          this.sweetspotData = response['Data'];
        }
        setTimeout(() => {
        }, 1000);
      },
      error: (err) => {
        console.log(err);
      }
    });
  }
}
